import React from 'react';
import { ButtonSizeEnum, PrimaryButton } from '../../button';
import { Title, Subtitle, Description, Container, HeaderContainer, TitleContainer, Footnote } from './StatusScreen.Styled';
export const StatusScreen = ({ title, subtitle, description, footnote, onSubmit, actionLabel, imageSrc, isLoading, imageComponent, hasInvertedHeader = false, children, }) => {
    const ImageComponent = imageComponent;
    return (React.createElement(Container, null,
        React.createElement(HeaderContainer, { reverse: hasInvertedHeader },
            imageComponent
                ? React.createElement(ImageComponent, { width: 120, height: 120, src: imageSrc })
                : React.createElement("img", { width: 120, height: 120, src: imageSrc, alt: "" }),
            React.createElement(TitleContainer, null,
                React.createElement(Title, null, title),
                subtitle && React.createElement(Subtitle, null, subtitle))),
        React.createElement(Description, null,
            description,
            children),
        onSubmit && (React.createElement(PrimaryButton, { isLoading: isLoading, onClick: onSubmit, size: ButtonSizeEnum.Large }, actionLabel)),
        footnote && (React.createElement(Footnote, null,
            React.createElement("span", null, footnote)))));
};
//# sourceMappingURL=StatusScreen.js.map